<template>
  <div class="field">
    <div class="field-name">{{ field.label }}</div>
    <AlchemyPictureSelect
      :key="localImage.value"
      :attachment="localImage.value"
      @[EMITTERS.IMAGE_SELECTED_EMITTER]="imageSelected"
    />
  </div>
</template>

<script>
import AlchemyPictureSelect from '../../admin/video_resources/components/AlchemyPictureSelect'
import AlchemyPicturesApiService from '../../admin/video_resources/services/alchemyPicturesApi.service'
import { EMITTERS } from '../../shared/utils/emitters'

export default {
  name: 'ImagePicker',
  components: { AlchemyPictureSelect },
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:value', 'change'],
  data() {
    return {
      EMITTERS,
      localImage: this.field,
    }
  },
  methods: {
    emitValueUpdate() {
      this.$emit('change', this.localImage)
      this.$emit('update:value', this.localImage.value)
    },
    imageSelected(alchemyPictureId) {
      AlchemyPicturesApiService.selectImage(alchemyPictureId)
        .then((response) => {
          this.localImage.value.description = response.data.picture.description
          this.localImage.value.alchemy_picture_id = response.data.picture.id
          this.localImage.value.url = response.data.picture.url
        })
        .finally(() => {
          this.emitValueUpdate()
        })
        .catch(console.error)
    },
  },
}
</script>

<style scoped lang="scss">
.field {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
  .field-name {
    width: 150px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
